<script lang="ts">
  import { selectedCustomerAccount } from "/@/stores/CustomerAccount"
  import { createForm } from "@tastyworks/svelte-forms-lib"
  import {
    ValidateYup,
    type buyingPowerParams,
  } from "@tastyworks/tastyworks-api"
  import { Button, Dialog, Input, Label } from "@tastyworks/ui-library"
  import { createEventDispatcher } from "svelte"

  let open = $state(false)

  const dispatcher = createEventDispatcher<{
    adjustBuyingPower: buyingPowerParams
  }>()

  const { form, handleSubmit, errors } = createForm({
    initialValues: {
      buyingPower: "",
      note: "",
    },
    onSubmit: async (values: buyingPowerParams) => {
      dispatcher("adjustBuyingPower", values)
      clearForm()
      open = false
    },
    validationSchema: ValidateYup.buyingPowerSchema,
  })

  const clearForm = () => {
    form.set({
      buyingPower: "",
      note: "",
    })
  }
</script>

<Dialog.Root bind:open>
  <Dialog.Trigger
    variant="secondary"
    disabled={$selectedCustomerAccount.account?.accountNumber == null}
    >Adjust Buying Power</Dialog.Trigger
  >

  <Dialog.Portal>
    <Dialog.Overlay />
    <Dialog.Content>
      <form class="flex flex-col gap-4" onsubmit={handleSubmit}>
        <div class="flex flex-col gap-2">
          <h1 class="text-center text-lg">
            Adjust buying power for {$selectedCustomerAccount.account
              ?.accountNumber}
          </h1>

          <Label for="adjustmentValue">Adjustment Value*:</Label>
          <Input
            id="adjustmentValue"
            class="w-full bg-white"
            bind:value={$form.buyingPower}
            type="number"
            required
            step="0.01"
          />
          {#if $errors.buyingPower}
            <p class="text-red-500">Must be a number</p>
          {/if}
        </div>

        <div class="flex flex-col gap-2">
          <Label for="note">Note*:</Label>
          <textarea
            id="note"
            style="flex-wrap: wrap; height:40mm;"
            class="w-full resize-none rounded-md p-2 text-wrap"
            bind:value={$form.note}
            required></textarea>
          {#if $errors.note}
            <p class="text-red-500">Must include a note</p>
          {/if}
        </div>
        <div class="flex w-full flex-row justify-center gap-3">
          <Dialog.Close variant="secondary" onclick={() => clearForm()}
            >Cancel</Dialog.Close
          >
          <Button name="submit" type="submit" variant="secondary">Submit</Button
          >
        </div>
      </form>
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>
